import { useImpersonationStore } from '@/features/admin';
import { useSessionStore } from '@/shared/api';

/**
 * Meekijken als iemand anders: van zichtbare toestand naar echt token.
 *
 * `features/admin` houdt bij *dat* er wordt meegekeken (en bewaart dat in
 * `sessionStorage`, zodat de balk een herlaad overleeft). De http-client leest
 * zijn token uit `useSessionStore`. Deze brug verbindt die twee: zolang er een
 * impersonatie loopt gaat dat tijdelijke token mee met elk verzoek, met de
 * bijbehorende `X-Tenant`. Stoppen zet het eigen token terug.
 *
 * De brug start bij het laden van de module en niet in een effect: het eerste
 * verzoek van het eerste scherm moet het juiste token al dragen, ook meteen na
 * een herlaad midden in een impersonatiesessie.
 */
export function startImpersonationBridge(): () => void {
    mirror();

    return useImpersonationStore.subscribe(mirror);
}

function mirror(): void {
    const session = useImpersonationStore.getState().session;

    useSessionStore.getState().setImpersonation(
        session
            ? {
                  token: session.token,
                  tenantId: session.tenantUuid,
                  tenantName: session.tenantName,
                  userName: session.userName,
                  expiresAt: session.expiresAt,
              }
            : null,
    );
}
